// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18A8G","top":"styles_top__3Xxw1","left":"styles_left__3HvW6","description":"styles_description__XAnhe"};